<template>
  <v-container class="appclick">
    <Header>
      <font-awesome-icon :icon="['fas', 'diagnoses']" />
      <font-awesome-icon :icon="['fas', 'cogs']" />
      <font-awesome-icon :icon="['fas', 'stamp']" />
      <span class="title">Correct Object classification</span>
    </Header>
    <v-row>
      <v-col>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Icon</th>
                <th class="text-left">Object</th>
                <th class="text-left">To check</th>
                <th class="text-left">Checked or<br />updated</th>
                <th class="text-left">Deleted</th>
                <th class="text-left">Automatic<br />by settings</th>
                <th class="text-left">Deleted due<br />loose end</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in event" :key="item.name">
                <td>
                  <font-awesome-icon :icon="item.icon" />
                </td>
                <td>{{ item.label }}</td>
                <td>
                  <router-link
                    :to="{
                      name: 'correct_class_test',
                      params: { class: item.class_id, class_status: 1 }
                    }"
                    ><font-awesome-icon :icon="['fas', 'balance-scale']" /><span
                      class="title"
                      >{{ item.n1 }}</span
                    ></router-link
                  >
                </td>
                <td>
                  <router-link
                    :to="{
                      name: 'correct_class_test',
                      params: { class: item.class_id, class_status: 3 }
                    }"
                    ><font-awesome-icon :icon="['fas', 'balance-scale']" /><span
                      class="title"
                      >{{ item.n2 }}</span
                    ></router-link
                  >
                </td>
                <td>
                  <router-link
                    :to="{
                      name: 'correct_class_test',
                      params: { class: item.class_id, class_status: 4 }
                    }"
                    ><font-awesome-icon :icon="['fas', 'balance-scale']" /><span
                      class="title"
                      >{{ item.n3 }}</span
                    ></router-link
                  >
                </td>
                <td>{{ item.n4 }}</td>
                <td>{{ item.n5 }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import Header from "@/components/Header.vue";
import ProjectService from "@/services/ProjectService.js";
export default {
  data() {
    return {
      event: {},
      height: 840
    };
  },
  components: {
    Header
  },
  mounted() {
    ProjectService.apiGet({
      nid: this.$session.get("PROJID"),
      type: "correct_class"
    })
      .then(response => {
        console.log(response.data);
        this.event = response.data.classes;
      })
      .catch(error => {
        console.log("Fout " + error.response);
      });
  }
};
</script>
<style scoped>
td {
  padding: 0px;
  height: 46px !important;
  font-size: 1.1rem !important;
}
.col,
.col-8,
.col-4 {
  width: 100%;
  padding: 0px;
}
</style>
